import { Injectable } from "@angular/core";
import { Guid } from "guid-typescript";
import * as moment from "moment";
import { Model_ResponseWorkflow, QueryParams_ResponseWorkflow } from 'src/app/app.models';
import { PlatformResult, API_RESULT_STATUS } from '../../platform/platform.service';
import { ResponseWorkflowOfflineDao } from './response-workflow-offline.dao';

export interface ResponseWorkflowApi {
    doSyncResponsesWorkflowAction(responsesWorkflowRaw: string);
    onResponsesWorkflowSynced(_result: PlatformResult);

    doClearResponsesWorkflowAction();
    onResponsesWorkflowCleared(_result: PlatformResult);

    doGetResponsesWorkflowAction(_queryParams: string);
    onResponsesWorkflowFetched(_result: PlatformResult);

    doInsertResponsesWorkflowAction(responseWorkflowsRaw: string);
    onResponsesWorkflowInserted(_result: PlatformResult);

    doCreateResponseWorkflowAction(responseWorkflowsRaw: string);
    onResponseWorkflowCreated(result: PlatformResult);

    doUpdateResponseWorkflowAction(responseWorkflowsRaw: string);
    onResponseWorkflowUpdated(result: PlatformResult);

    doGetResponseWorkflowAction(guid: string);
    onResponseWorkflowFetched(result: PlatformResult);

    doDeleteResponseWorkflowAction(guid: string);
    onResponseWorkflowDeleted(result: PlatformResult);
}

@Injectable()
export class ResponseWorkflowOfflineAndroidDao extends ResponseWorkflowOfflineDao {
    doSyncResponsesAction(_responses: Model_ResponseWorkflow[]): Promise<void> {
        return new Promise((resolve, reject) => {
            window['ResponseWorkflowApi'].onResponsesWorkflowSynced = (_result: PlatformResult) => {
                delete window['ResponseWorkflowApi'].onResponsesWorkflowSynced;
                if (_result.status == API_RESULT_STATUS.SUCCESS) {
                    resolve();
                } else {
                    reject(_result.error);
                }
            };
            const responseWorkflowApi: ResponseWorkflowApi = window['ResponseWorkflowApi'];
            responseWorkflowApi.doSyncResponsesWorkflowAction(JSON.stringify(_responses))
        });
    }

    doClearResponsesAction() {
        return new Promise<void>((resolve, reject) => {
            window['ResponseWorkflowApi'].onResponsesWorkflowCleared = (_result: PlatformResult) => {
                delete window['ResponseWorkflowApi'].onResponsesWorkflowCleared;
                if (_result.status == API_RESULT_STATUS.SUCCESS) {
                    resolve();
                } else {
                    reject(_result.error);
                }
            };
            const responseWorkflowApi: ResponseWorkflowApi = window['ResponseWorkflowApi'];
            responseWorkflowApi.doClearResponsesWorkflowAction()
        });
    }

    doGetResponsesAction(_queryParams?: QueryParams_ResponseWorkflow): Promise<Model_ResponseWorkflow[]> {
        if (_queryParams === undefined) 
            _queryParams = new QueryParams_ResponseWorkflow();

        return new Promise<Model_ResponseWorkflow[]>((resolve, reject) => {
            window['ResponseWorkflowApi'].onResponsesWorkflowFetched = (_result: PlatformResult) => {
                delete window['ResponseWorkflowApi'].onResponsesWorkflowFetched;
                if (_result.status == API_RESULT_STATUS.SUCCESS) {
                    resolve(_result.datas);
                } else {
                    reject(_result.error);
                }
            };
            const responseWorkflowApi: ResponseWorkflowApi = window['ResponseWorkflowApi'];
            responseWorkflowApi.doGetResponsesWorkflowAction(JSON.stringify(_queryParams));
        });
    }

    doInsertResponsesAction(_responses: Model_ResponseWorkflow[]): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            window['ResponseWorkflowApi'].onResponsesWorkflowInserted = (_result: PlatformResult) => {
                delete window['ResponseWorkflowApi'].onResponsesWorkflowInserted;
                if (_result.status == API_RESULT_STATUS.SUCCESS) {
                    resolve();
                } else {
                    reject(_result.error);
                }
            };
            const responseWorkflowApi: ResponseWorkflowApi = window['ResponseWorkflowApi'];
            responseWorkflowApi.doInsertResponsesWorkflowAction(JSON.stringify(_responses));
        });
    }

    doSaveResponsesAction(_response: Model_ResponseWorkflow): Promise<Model_ResponseWorkflow> {
        return new Promise<Model_ResponseWorkflow>((resolve, reject) => {
            const responseWorkflowAPi: ResponseWorkflowApi = window['ResponseWorkflowApi'];
            if (_response.ID === undefined && _response.GUID_SYNCHRONISATION === undefined) {
                _response.DATE_CREATION = moment().format();
                _response.GUID_SYNCHRONISATION = Guid.create().toString();
                _response.SYNCED = false;
                window['ResponseWorkflowApi'].onResponseWorkflowCreated = (_result: PlatformResult) => {
                    delete window['ResponseWorkflowApi'].onResponseWorkflowCreated;
                    if (_result.status == API_RESULT_STATUS.SUCCESS) {
                        resolve(_response);
                    } else {
                        reject(_result.error);
                    }
                };
                responseWorkflowAPi.doCreateResponseWorkflowAction(JSON.stringify(_response));
            } else {
                _response.DATE_MODIFICATION = moment().format();
                window['ResponseWorkflowApi'].onResponseWorkflowUpdated = (_result: PlatformResult) => {
                    delete window['ResponseWorkflowApi'].onResponseWorkflowUpdated;
                    if (_result.status == API_RESULT_STATUS.SUCCESS) {
                        resolve(_response);
                    } else {
                        reject(_result.error);
                    }
                };
                responseWorkflowAPi.doUpdateResponseWorkflowAction(JSON.stringify(_response));
            }
        });
    }

    doGetResponseAction(_guid: string): Promise<Model_ResponseWorkflow> {
        return new Promise((resolve, reject) => {
            window['ResponseWorkflowApi'].onResponseWorkflowFetched = (_result: PlatformResult) => {
                delete window['ResponseWorkflowApi'].onResponseWorkflowFetched;
                if (_result.status == API_RESULT_STATUS.SUCCESS) {
                    resolve(_result.datas);
                } else {
                    reject(_result.error);
                }
            };
            const responseWorkflowAPi: ResponseWorkflowApi = window['ResponseWorkflowApi'];
            responseWorkflowAPi.doGetResponseWorkflowAction(_guid);
        });
    }

    doDeleteResponseWorkflowAction(_guid: string): Promise<void> {
        return new Promise((resolve, reject) => {
            window['ResponseWorkflowApi'].onResponseWorkflowDeleted = (_result: PlatformResult) => {
                delete window['ResponseWorkflowApi'].onResponseWorkflowDeleted;
                if (_result.status == API_RESULT_STATUS.SUCCESS) {
                    resolve();
                } else {
                    reject(_result.error);
                }
            };
            const responseWorkflowAPi: ResponseWorkflowApi = window['ResponseWorkflowApi'];
            responseWorkflowAPi.doDeleteResponseWorkflowAction(_guid);
        });
    }
}
